<script>
	import { Table } from "@sveltestrap/sveltestrap";
	import Pagination from "../../../../components/CustomPaginate/Pagination.svelte";
	import CustomModal from "./BookingModal/MainModal.svelte";
	import LoaderContainer from "../../../../components/Loader/LoaderContainerSort.svelte";
	import { convert } from "../../../../services/helpers";
	import { fetchIssueModal, bookingId } from "../../../../store/store";
	import FontAwesomeIcon from "src/components/FontAwesomeIcon/FontAwesomeIcon.svelte";
	import { faPaperclip as fasPaperclip } from "@fortawesome/free-solid-svg-icons";
	import { faArrowDownShortWide as fasArrowDownShortWide } from "@fortawesome/free-solid-svg-icons";
	import { faArrowUpShortWide as fasArrowUpShortWide } from "@fortawesome/free-solid-svg-icons";
	import { renderBookingStatus, renderDuration } from "src/utils/misc";
	export let data;
	export let trigerSort;

	const handleModal = (id) => {
		fetchIssueModal.set(true);
		bookingId.set(id);
	};

	let desc = "asc";
	function handleSort(num) {
		if (desc == "desc") {
			desc = "asc";
		} else {
			desc = "desc";
		}
		trigerSort({ desc, num });
	}

	const bookingStatuses = {
		Pending: `<p class="status-bar status-bar-2">Pending</p>`,
		Confirmed: `<p class="status-bar bg-info">Confirmed</p>`,
		Ongoing: `<p class="status-bar bg-primary">Ongoing</p>`,
		Cancelled: `<p class="status-bar bg-danger">Cancelled</p>`,
		"Cancelled (GetGO)": `<p class="status-bar bg-danger">Admin Cancelled</p>`,
		Completed: `<p class="status-bar status-bar-1">Completed</p>`,
	};

	let sortByStartDate = "scheduledStart";
	let sortByEndDate = "scheduledEnd";
</script>

<LoaderContainer>
	<div class="tbodyDiv">
		<Table responsive hover>
			<thead class="sticky-top">
				<tr>
					<th>Booking ID</th>
					<th
						>Start Date/ Time &nbsp;
						<!-- svelte-ignore a11y-click-events-have-key-events -->
						<!-- svelte-ignore a11y-interactive-supports-focus -->
						<button
							type="button"
							style="background:none;border:none;padding:0;cursor:pointer;color:inherit;vertical-align:middle;"
							on:click={() => handleSort(sortByStartDate)}
							>{#if desc == "desc"}
								<img
									src="/assets/icon-sort-down-thin.svg"
									alt="icon-sort-down"
								/>
							{:else}
								<img
									src="/assets/icon-sort-up-thin.svg"
									alt="icon-sort-up"
								/>
							{/if}
						</button></th
					>
					<th
						>End Date/ Time &nbsp;
						<!-- svelte-ignore a11y-interactive-supports-focus -->
						<!-- svelte-ignore a11y-click-events-have-key-events -->
						<button
							type="button"
							style="background:none;border:none;padding:0;cursor:pointer;color:inherit;vertical-align:middle;"
							on:click={() => handleSort(sortByEndDate)}
							>{#if desc == "desc"}
								<img
									src="/assets/icon-sort-down-thin.svg"
									alt="icon-sort-down"
								/>
							{:else}
								<img
									src="/assets/icon-sort-up-thin.svg"
									alt="icon-sort-up"
								/>
							{/if}
						</button></th
					>
					<th>Duration</th>
					<th>Issues</th>
					<th>Status</th>
				</tr>
			</thead>
			<tbody>
				{#each data as { id, bookingNo, scheduledStart, scheduledEnd, duration, bookingStatus, issueReported }}
					<tr>
						<td>
							<p>
								<span> {bookingNo} </span>
							</p>
						</td>
						<td>
							<p>
								<span> {convert(scheduledStart)} </span>
							</p>
						</td>
						<td>
							<p>
								<span> {convert(scheduledEnd)} </span>
							</p>
						</td>
						<td>
							<p>
								<span>
									{renderDuration(duration)}
								</span>
							</p>
						</td>
						<td>
							<p>
								{#if issueReported > 0}
									<button
										type="button"
										style="background:none;border:none;padding:0;cursor:pointer;color:inherit;vertical-align:middle;"
										on:click={() => handleModal(id)}
									>
										<FontAwesomeIcon icon={fasPaperclip} />
									</button>
								{/if}
							</p>
						</td>
						<td>
							{@html bookingStatuses[
								renderBookingStatus(bookingStatus)
							]}
						</td>
					</tr>
				{/each}
			</tbody>
		</Table>
		{#if data.totalCount == 0}
			<p class="text-center">No data to display</p>
		{/if}
	</div>
	<Pagination totalRecord={data.totalCount} bookingStatus />
	{#if $fetchIssueModal}
		<CustomModal />
	{/if}
</LoaderContainer>

<style>
	.tbodyDiv {
		max-height: clamp(38em, 76vh, 550px);
		overflow: hidden;
		margin-bottom: 15px;
		overflow: auto;
	}
</style>
